import { Link } from "react-router-dom";

export default function SharedButton({
  variant = "primary",
  type = "button",
  to,
  children,
  onClick,
  disabled,
  className = "",
  block = false,
}) {
  const classes = `shared-btn shared-btn--${variant}${block ? " shared-btn--block" : ""}${className ? ` ${className}` : ""}`;

  if (to) {
    return (
      <Link to={to} className={classes} onClick={onClick} aria-disabled={disabled}>
        {children}
      </Link>
    );
  }

  return (
    <button type={type} className={classes} onClick={onClick} disabled={disabled}>
      {children}
    </button>
  );
}
